import EventType from '../enums/events/EventType'

export const base_order_funeral = [
  EventType.DECLARATION,
  EventType.CREMATION,
  EventType.CREMATORIUM_ARRIVAL,
  EventType.CEREMONY,
  EventType.ASHES_RECOVERY,
  EventType.BURIAL,
  EventType.EXHUMATION,
  EventType.WAKE,
  EventType.BODY_RAISING,
  EventType.REUNION,
  EventType.VISIT,
  EventType.ROOM_OCCUPANCY,
  EventType.RECEPTION,
  EventType.MARBRERIE,
  EventType.APPOINTMENT,
]

export const base_order_remain = [
  EventType.TRANSFERT,
  EventType.THANATO,
  EventType.COFFIN_PLACING,
  EventType.COFFIN_CLOSING,
  EventType.SEALING_PROCESS,
]
export const base_order_infos_dossier = [
  'informations',
  'deceased',
  // 'profession',
  'marital_status',
  'parent',
  // 'children',
  'death',
  'other',
  'cemetery',
  'partners'
]
